import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import Filter from '@/components/monitors-route/agents/filter.jsx'
import { AgentMonitorTable } from '@/components/monitors-route/agents/table.jsx'
import { sendGetAgentOnline } from '@/utils/webrtc_socket.js'
import useCallStore from '@/store/call-store'

export const Route = createFileRoute('/_auth/monitors/agents')({
  component: Agent,
})

function Agent() {
  const isSocketConnected = useCallStore((state) => state.isSocketConnected)

  useEffect(() => {
    sendGetAgentOnline()
  }, [isSocketConnected])

  return (
    <div>
      <div className="gap-4 p-4 pb-1">
        <Filter />
      </div>
      <div className="flex-grow gap-4 overflow-auto p-4 pt-1">
        <AgentMonitorTable />
      </div>
    </div>
  )
}
